/*
    Header.jsx
    サンタナム　リシ

    Header.jsxは、アプリヘッダーの定義。このコンポーネントは、ファイル外部
    で定義されたスタイルを使用して、アプリケーションのヘッダーを表示します。
*/

import React, { useState } from "react";
import { useCms } from "../cms/CmsProvider";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { FaHome, FaUser, FaBars, FaTimes, FaChild, FaHeart, FaNewspaper } from "react-icons/fa";
import logo from "../assets/img/logo/npocde logo.png";
import LanguageSwitcher from "../components/atoms/LanguageSwitcher";

export default function Header() {
  const { t, text, image, isJa } = useCms("site");
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <header className="app-header">
      <Link to="/" className="header-left">
        <div className="logo-container">
          <img src={image("logo", logo)} alt="NPO CDE Logo" className="logo" />
        </div>
        <div className="organization-name">{text("organizationName", "header.organizationName")}</div>
      </Link>

      {/* Donate Button, Language Switcher and Menu Icon */}
      <div className="header-actions">
        <Link to="/donate" className="header-donate-button">
          <FaHeart className="donate-icon" /> {t('nav.donate')}
        </Link>
        <div className={`language-switcher-wrapper ${menuOpen ? 'hidden' : ''}`}>
          <LanguageSwitcher />
        </div>
        <div className="menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
          {menuOpen ? <FaTimes /> : <FaBars />}
        </div>
      </div>

      <motion.div
        className={`menu-background ${menuOpen ? "show" : ""}`}
        initial={{ opacity: 0 }}
        animate={{ opacity: menuOpen ? 1 : 0 }}
        transition={{ duration: 0.3 }}
        onClick={() => setMenuOpen(false)}
      />

      <motion.nav
        className={`side-menu ${menuOpen ? "show" : ""}`}
        initial={{ x: "100%" }}
        animate={{ x: menuOpen ? "0%" : "100%" }}
        transition={{ type: "tween", duration: 0.3 }}
      >
        <ul>
          <li><Link to="/" onClick={() => setMenuOpen(false)}><FaHome /> {t('nav.home')}</Link></li>
          <li><Link to="/about" onClick={() => setMenuOpen(false)}><FaUser /> {t('nav.about')}</Link></li>
          <li><Link to="/programs" onClick={() => setMenuOpen(false)}><FaChild /> {t('nav.programs')}</Link></li>
          <li><Link to="/donate" onClick={() => setMenuOpen(false)}><FaHeart /> {t('nav.donate')}</Link></li>
                    <li><Link to="/news" onClick={() => setMenuOpen(false)}><FaNewspaper /> {isJa ? "\u304a\u77e5\u3089\u305b" : "News"}</Link></li>
        </ul>
      </motion.nav>
    </header>
  );
}
